import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export function AdminMessageDialog({ open, onClose, otherUserId, displayName }) {
  const navigate = useNavigate();
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim() || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/threads", { other_user_id: otherUserId, initial_message: body.trim() });
      toast.success("Message sent");
      setBody("");
      onClose();
      navigate(`/messages/${data.id}`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-lg max-h-[calc(100dvh-2rem)] overflow-y-auto" data-testid="admin-message-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif">Message {displayName}</DialogTitle>
          <DialogDescription>
            Sent as Last Bookmark admin. If you already have a direct conversation, this message is added to it.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={send} className="space-y-4">
          <label htmlFor="admin-message-body" className="sr-only">Message</label>
          <textarea
            id="admin-message-body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={5}
            maxLength={4000}
            autoFocus
            placeholder="Write your message…"
            className="w-full rounded-lg border bg-background px-3 py-2 text-sm"
            data-testid="admin-message-body"
          />
          <div className="flex flex-wrap justify-end gap-2">
            <button type="button" onClick={onClose} className="btn-ghost border min-h-[44px]" data-testid="admin-message-cancel">Cancel</button>
            <button
              type="submit"
              disabled={!body.trim() || busy}
              className="btn-primary inline-flex items-center gap-2 min-h-[44px] disabled:opacity-60"
              data-testid="admin-message-send"
            >
              <Send size={14} /> {busy ? "Sending…" : "Send message"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
